import React, { useCallback, useEffect, useState } from 'react';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { URL } from '../../../../constant';
import { memberSelAPI } from '../../../../api/accountAPI';
import { errorMessage } from '../../../../redux/errorState';
import { useAlert, useInputs, useRequest, useUserInfo } from '../../../../hooks';
import { birthRegExp,  emailMasking,  phoneRegExp } from '../../../../utils/utilityEtc';
import { BackButtons } from '../../../navigate';


function MemberAuth() {  
  const history = useHistory();
  const { info } = useUserInfo();
  const [Alert] = useAlert();
  const dispatch = useDispatch();
  const [termOnOff, setTermOnOff] = useState(false);
  const [checkedTerm, setCheckTerm] = useState(false);
  const [formData, handleFormData] = useInputs({
    name: '',
    birth: '',
    phone: '',
  });
  const [errorCheck, setErrorCheck] = useState({
    phone: false,
    birth: false,
  })

  const [memberSelAPICall, memberInfo] = useRequest((data) =>
    memberSelAPI(data), true
  );

  useEffect(() => {
    if (!memberInfo) return;

    const { code, resp } = memberInfo;
    if (code !== 'S000000') {
      dispatch(errorMessage(
        code,
        resp?.msg
      ))
    } else {
      // 이미 입회 회원인 경우
      if (resp?.emailCertYn === 'Y') {
        Alert(`이미 인증된 계정이 있습니다.<br/>아래의 계정으로 로그인해주세요.<br/>${emailMasking(resp.emailAdrs)}`);
        return;
      }
      
      const { learner, parentCstmrNo } = memberInfo.resp;
      history.push({
        pathname: URL.ACCOUNT.GM_MEMBER_AUTH_SUCCESS,
        state: {
          result: {
            parentCstmrNo,
            learner
          }
        }
      })
    }

  }, [memberInfo]);

  const handleBlur = useCallback((e) => {
    const name = e.target.name;
    const value = e.target.value;
    let result = false;

    if (!value) return;

    if (name === 'phone') {
      result = !phoneRegExp(value);
    } else if (name === 'birth') {
      result = !birthRegExp(value);
    }

    setErrorCheck({
      ...errorCheck,
      [name]: result
    });

  }, [errorCheck]);

  const handleTermOnOff = useCallback(() => {
    setTermOnOff(!termOnOff);
  }, [termOnOff]);

  const handleCheckedTerm = useCallback(() => {
    setCheckTerm(!checkedTerm);
  }, [checkedTerm]);

  const onSubmit = () => {
    const { channelCode } = info;
    const { name, phone, birth } = formData;
    memberSelAPICall({
      chnCd: channelCode,
      nm: name,
      brthmt: birth,
      phone,
    })
  }

  return (
    <React.Fragment>
      <div className="header_top">
        <div className="inner">
          <div className="btns_wrap header-trans cls">
            <div className="app_btn">
              <BackButtons />
            </div>
            <div className="tit_gm center_tit24">입회 회원 인증</div>
          </div>
        </div>
      </div>
      <div className="layout-def layout-sl bg_gray2">
        <div className="container">
          <div className="inner">
            <div className="tit_txt">
              AI바로셈 입회 시 기재하셨던 <br className="hide_pc hide_t" />
              부모 정보를 입력해 주세요.
            </div>

            <div className="wirte_form gm_ver w520 pb0">
              <form>
                <section>
                  <div className="item">
                    <div className="input_title">이름</div>
                    <div className="input_cont h56">
                      <div className="input_box white_box">
                        <input
                          type="text"
                          name="name"
                          placeholder="입회한 부모 이름 입력"
                          value={formData.name}
                          onChange={handleFormData}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="input_title">생년월일</div>
                    <div className="input_cont h56">
                      <div className="input_box white_box">
                        <input
                          type="number"
                          name="birth"
                          placeholder="생년월일 입력 예) 19891119"
                          value={formData.birth}
                          onChange={handleFormData}
                          onBlur={handleBlur}
                        />
                      </div>
                      {
                        errorCheck.birth && (
                          <div className="info_txt red">
                            올바른 생년월일 형식이 아닙니다.
                          </div>
                        )
                      }
                    </div>
                  </div>
                  <div className="item">
                    <div className="input_title">휴대폰번호</div>
                    <div className="input_cont h56">
                      <div className="input_box white_box">
                        <input
                          type="number"
                          name="phone"
                          placeholder="-없이 휴대폰 번호 입력"
                          value={formData.phone}
                          onChange={handleFormData}
                          onBlur={handleBlur}
                        />
                      </div>
                      {
                        errorCheck.phone && (
                          <div className="info_txt red">
                            올바른 휴대폰번호 형식이 아닙니다.
                          </div>
                        )
                      }
                    </div>
                  </div>
                </section>
                <div className="terms_chk">
                  <div className="chk_wrap">
                    <div>
                      <div className="custom-radio-wrap gray">
                        <input
                          type="checkbox"
                          id="input-chk1"
                          name="checked"
                          checked={checkedTerm}
                          onChange={handleCheckedTerm}
                        />
                        <label htmlFor="input-chk1">
                          (필수) 웅진씽크빅 입회회원 서비스 제공
                          <span className="hide_pc hide_t">에</span> 동의
                        </label>
                      </div>
                    </div>
                    <div>
                      <button
                        type="button"
                        className="toggle js_on"
                        onClick={handleTermOnOff}
                      >
                        약관 토글버튼
                      </button>
                    </div>
                  </div>
                  <div className={clsx({
                    "txt_wrap": true,
                    "on": termOnOff
                  })}>
                    <div className="box">
                      <div className="inner_cont">
                        1. 개인정보의 수집,이용 목적 : AI바로셈 입회 인증 및 조회<br />
                        2. 수집하려는 개인정보의 항목 : 입회 계약 및 신청서에 기재한 부모의 성명 / 생년월일 / 휴대폰번호<br />
                        3. 개인정보의 보유 및 이용 기간 : 원칙적으로 개인정보 수집 및 이용목적이 달성 된 후에는 해당 정보를 지체 없이 파기합니다.<br />
                        4. 개인정보의 파기 : 수집 및 이용목적 달성 또는 보관 후 6개월 경과시, 동의철회를 하는 경우, 분쇄/소각 등 재생 불가능한 방법으로 지체 없이 파기합니다.<br />
                        &nbsp;&nbsp;- 고객의 개인정보는 당사의기술적 관리적 보호조치에 따라 안전하게 보관됨을 알려드립니다.<br />
                        5. 만 14세 미만의 미성년자 보호 : 아동의 서비스가입 시 고지한 범위 또는 이용약관에 명시한 범위를 넘어 아동의 개인정보를 이용하는 경우 아동의 법정대리인의 동의를 얻도록 하고 있습니다.<br />
                        6. 위 내용에 대하여 동의를 거부할 권리가 있으며, 미동의시 입회조회가 제한될 수 있습니다.<br />
                        &nbsp;&nbsp;- 고객의 개인정보 취급처리방침에 대한 자세한 내용은 당사 홈페이지 내 개인정보 취급처리방침을 참고 하시기 바랍니다.
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <div className="bottom_sticky">
              <div className="btn_cont">
                <button
                  className="btn btn-blue"
                  disabled={
                     !birthRegExp(formData.birth)
                    || !phoneRegExp(formData.phone)
                    || formData.name.length === 0
                    || !checkedTerm
                  }
                  onClick={onSubmit}
                >확인</button>
              </div>
              <div className="txt_cont">
                <p>인증이 안될 경우 고객센터(1577-1500)로 문의해 주세요.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default MemberAuth;